import React from 'react';
import * as S from './Anchor.styles';

interface Props {
  value: {
    _key: string;
    _type: 'anchor';
    type: 'anchor';
    id: string;
  };
}

export const AnchorBlock = ({ value: { id } }: Props) => <S.Anchor id={id} />;
